
export const USERS_TITLE = [
  { text: 'Mr.', value: 'Mr.' },
  { text: 'Mrs.', value: 'Mrs.' },
  { text: 'Ms.', value: 'Miss' },
];

export const ROLES = [
  { text: 'Pleasure Flyer', value: 'Pleasure Flyer' },
  { text: 'Aviation Professional', value: 'Aviation Professional' },
  { text: 'Aviation Associated Bussiness', value: 'Aviation Associated Business' },
  { text: 'Others', value: 'Others' },
]

export enum USER_TYPES {
  USER = 'USER',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  MRT_TEAM = 'MRT_TEAM'
}

export const MAX_SIZES = {
  MAX_IMAGE_SIZE_FOR_CERTIFICATE_UPLOAD: 5
}

export const POST_CREATE_OPTIONS = [
  { title: 'Individual', value: 'NORMAL' },
  { title: 'Business', value: 'BUSINESS' },
]

export enum ADVERTISEMENT_TYPE {
  NORMAL_USER = 'NORMAL_USER',
  ADMIN = 'ADMIN',
  BUSINESS = 'BUSINESS',
  EVENT = 'EVENT'
}

export enum POST_TYPES {
  NORMAL_POST = 'NORMAL_POST',
  BUSINESS = 'BUSINESS',
  REVIEW = 'BUSINESS_POST',
  COMMUNITY_GROUP_POST = 'COMMUNITY_GROUP_POST'
}

export const PAGELIMIT = {
  TOPICS: 20,
  ANSWERS: 10,
  REPLY: 5,
  FOLLOWER_FOLLOWING: 20,
  NEARBYUSERS: 7,
  NEARBYUSERS_LIST: 10,
  BUSINESS_LISTING: 20,
  BUSINESS_REVIEWS: 10,
  EVENT_CATEGORY: 10,
  POST_COMMENTS: 2,
  EVENT_LISTING: 10,
  TRENDING_TOPIC: 10,
  AVTOPIA_BUSINESS: 10,
  TOPIC_CATEGORY: 15,
  EVENT_CARD: 4,
  NOTIFICATION_LIST: 10,
  NOTIFICATION_VIEW_ALL_LIST: 10,
  POSTS_LISTING: 3,
  ADVERTISEMENT_LIST: 20,
  USER_REVIEWS_LIST: 10,
  POST_LIKED_USERS_LIST: 4,
  FOLLOWUNFOLLOW: 20,
  COMMENT_REPLIES: 5,
  SEEALL_EVENTS: 20,
  COMMUNITY_GROUP_MEMBERS: 20
}


export const BREADCRUMB_CONSTANTS = {
  SQUAKPIT: {
    name: 'Forum',
    description: "Forum description",
    backgroundClass: 'squawkpit'
  },
  BUSINESS: {
    name: 'Business',
    description: "business description",
    backgroundClass: 'business'
  },
  BUSINESS_REVIEWS: {
    name: 'Business Reviews',
    description: '',
    backgroundClass: ''
  },
  POST_COMMENT_DETAILS: {
    name: 'Comment Details',
    description: 'Post Comment Details',
    backgroundClass: 'post'
  },
  NEARBY_BUSINESS: {
    name: 'Nearby Business',
    description: "business description",
    backgroundClass: 'business'
  },
  ADD_BUSINESS: {
    name: 'Add Business',
    description: "business description",
    backgroundClass: 'business'
  },
  CLAIM_BUSINESS: {
    name: 'Claim Business',
    description: "business description",
    backgroundClass: 'business'
  },
  CLAIM_NEARBY_BUSINESS: {
    name: 'Claim a Business',
    description: "business description",
    backgroundClass: 'business'
  },
  EDIT_BUSINESS: {
    name: 'Edit Business',
    description: "business description",
    backgroundClass: 'business'
  },
  MY_BUSINESS: {
    name: 'My Business',
    description: 'My Business Description'
  },
  PROFILE: {
    name: 'Profile',
    description: 'Profile Details'
  },
  EVENTS: {
    name: 'Nearby Events',
    description: "events description",
    backgroundClass: 'events'
  },
  CHAT: {
    name: 'Chat',
    description: "Chat description",
    backgroundClass: 'chat'
  },
  ADVERTISE: {
    name: 'Advertise with Avtopia',
    description: "Advertisement description",
    backgroundClass: 'Advertisement'
  },
  VIEW_ALL_FOLLOWERS: {
    name: 'Followers',
    description: 'Followers description',
    backgroundClass: 'Followers'
  },
  VIEW_ALL_FOLLOWING: {
    name: 'Following',
    description: 'Following description',
    backgroundClass: 'Following'
  },
  POST_DETAIL: {
    name: 'Post',
    description: 'Post description',
    backgroundClass: 'Post'
  },
  VIEW_ALL_BUSINESS_FOLLOW: {
    name: 'Business',
    description: 'Following description',
    backgroundClass: 'Following'
  },
}

export enum NOTIFICATION_STATUS {
  ON = 'ON',
  OFF = 'OFF'
}


export const SEARCH_TYPES = [
  { title: 'Business', value: 'business' },
  { title: 'People', value: 'user' },
  { title: 'Event', value: 'event' },
]


export enum SEARCH_TYPES_ENUM {
  USER = 'user',
  BUSINESS = 'business',
  EVENT = 'event',
}
export enum SEARCH_DATA_TYPE {
  USERS = 'users',
  BUSINESS = 'business',
  EVENTS = 'events',
}

export const SEARCH_ALL_TYPES = { title: 'All', value: 'all' }

export enum BOTTOM_SHEET_TYPE {
  TRENDING_TOPIC = 'TRENDING_TOPIC',
  NEARBY_USERS = 'NEARBY_USERS'
}


export const NOTIFICATION_PUSH_CONSTANTS = {
  BULK_NOTIFICATION: "1",
  ONE_TO_ONE: "2",
  AOG_REQUEST: "3",
  FOLLOW_USER: "4",
  CREATE_BUSINESS: "5",
  CREATE_EVENT: "6",
  FOLLOW_BUSINESS: "7",
  CREATE_TOPIC_ANSWER: "8",
  CHAT_NOTIFICATION: "9",
  MENTION_USER_POST: "10",
  // MENTION_USER_COMMENT: "11",
  CREATE_NEW_POST: "12",
  MENTION_POST_COMMENT: "13",
  COMMENT_ON_POST: "14",
  POST_COMMENT_REPLY: "15",
  ADDED_BUSINESS_REVIEW: "16",
  CREATE_TOPIC: "17",
  CREATE_ANSWER_REPLY: "18",
  AOG_REQUEST_ACCEPTED: "19",
  AOG_REQUEST_REJECTED: "20",
  AOG_REQUEST_SCHEDULED: "21",
  AOG_REQUEST_CANCELED: "22",
  AOG_REQUEST_COMPLETED: "23",
  AOG_REQUEST_SCHEDULED_TIME: "24",
  POST_LIKE: "26",
  COMMENT_LIKE: "27",
  MENTION_POST_COMMENT_REPLY: "25",
  TOPIC_UPVOTE: "28",
  TOPIC_ANSWER_UPVOTE: "29",
  ANSWER_REPLY_UPVOTE: "30",
  TOPIC_DOWNVOTE: "31",
  TOPIC_ANSWER_DOWNVOTE: "32",
  ANSWER_REPLY_DOWNVOTE: "33",
  NEW_COMMENT_ON_FOLLOWED_TOPIC: "42",
  NEW_LIKE_ON_FOLLOWED_TOPIC: "43",
  NEW_COMMENT_ON_FOLLOWED_TOPIC_ACTIVITY: "44",
  EDIT_TOPIC: "45",
}

export enum CONTENT_MANAGEMENT_CONSTANTS {
  PRIVACY_POLICY = '1',
  TERM_AND_CONDITION = '2',
  ABOUT_US = '5',
  CONTACT_US = '4'
}
